import { styled } from '@mui/system'
import { Grid, Box, Paper, Typography } from '@mui/material'

export const TabItem = styled('a')(`
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    text-decoration: none;
    margin-right: 12px;
    &:hover {
        text-decoration: none;
        color: #0066DB;
    }
    &.active, &.selected {
        border-bottom-color: #0066DB;
        color: #0066DB;
    }
`)

export const TabWrapper = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
    padding: 16px 20px;
    position: relative;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);

    &.active {
        position: sticky;
        top: -45px;
    }

    &.first-tab, &.first-tab.active {
        top: 0;
        & h4{
            display: none;
        }       
    }

    & .dynamicTourText span {
      margin-top: 17px;
    }

`)

export const TabTitle = styled('h4')(`
    width:100%;
    display: inline-block;
    font-size: 19px;
    font-weight: 400;
    color: #333;
    transition: all 0.3s ease;
    padding-bottom: 15px;
`)

export const TabMainWrapper = styled(Box)(`
    position: relative;
`)


